export default {
  desktop: '(min-width: 1024px)',
  maxDesktop: '(max-width: 1024px)',
  bigDesktop: '(min-width: 1600px)',
}
